import { handleResponse, SERVER_HOST } from "@api";
import { TFeedback } from "@components/types";
import axios from "axios";

export const addFeedback = async (order: TFeedback) => {
    let axiosMethod = order?.id ? axios.put : axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/feedbacks/${order?.id ? order?.id : ''}`,
        JSON.stringify(order),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export async function getMyFeedback(order_id: string) {
    const response = await axios.get(`${SERVER_HOST}/api/v1/feedbacks/?${order_id?.length > 0 ? `order_id=${order_id}&` : ""}type=FEEDBACK&skip=0&limit=10`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }
    });
    const feedbacks: TFeedback[] = handleResponse(response);
    return feedbacks.length > 0 ? feedbacks[0] : null
}